import { render } from "./vdvcisonline.vue?vue&type=template&id=32a5fa02&scoped=true"
import script from "./vdvcisonline.vue?vue&type=script&lang=js"
export * from "./vdvcisonline.vue?vue&type=script&lang=js"

import "./vdvcisonline.vue?vue&type=style&index=0&id=32a5fa02&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a5fa02"]])

export default __exports__